module.exports = __webpack_public_path__ + "static/03-90460303026e309b311ae862c39600e0.jpg";